export class ReferralModel {
  public ind_first_name: string = undefined;
  public ind_last_name: string = undefined;
  public ind_badge_name: string = undefined;
  public cst_recno: number = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          switch (key) {
            default:
              this[key] = source[key];
          }
        }
      }
    }
  }

}
